import lodash from "lodash";
import { toSizeInKb } from "./../../ricos-content";
class FilePluginService {
  createLoadingData(file, _, componentData) {
    const { name, size } = file;
    const type = name.split(".").pop();
    return {
      componentData: {
        ...componentData,
        name,
        size,
        sizeInKb: toSizeInKb(size),
        type
      },
      componentState: {
        loading: true,
        tempData: true
      }
    };
  }
  createPluginData(uploadedData, componentData) {
    const { data } = uploadedData;
    const { url, id, privacy } = data;
    const src = url ? { url } : { id };
    return {
      ...lodash.omit(componentData, ["tempData", "loading"]),
      ...lodash.omit(data, "url", "id", "privacy"),
      src: { ...src, privacy }
    };
  }
  createErrorData(error, componentData) {
    return {
      ...lodash.omit(componentData, ["tempData", "loading"]),
      error
    };
  }
}
export {
  FilePluginService
};
//# sourceMappingURL=filePluginService.js.map
